

































import { uniqueId } from 'lodash-es';

export default {
  props: ['show', 'header', 'okText', 'cancelText'],
  data() {
    return {
      MODAL_NAME: uniqueId('confirm'),
    };
  },
  methods: {
    showModal() {
      this.$modal.show(this.MODAL_NAME);
    },
    hideModal() {
      this.$modal.hide(this.MODAL_NAME);
    },
  },
  mounted() {
    this.showModal();
  },
};
